import React from 'react';
import PropTypes from 'prop-types';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFileAlt,
  faPencilAlt,
  faShareAlt,
  faTrashAlt,
  faSearch,
  faCheck,
  faArrowLeft,
  faArrowRight,
  faUserClock,
  faTv,
  faFilm,
  faSitemap,
  faSignal,
  faEdit,
  faPaste,
  faQuestion,
  faCaretUp,
  faCaretDown,
  faDownload,
  faTimes,
  faTimesCircle,
  faAngleUp,
  faAngleDown,
  faAngleLeft,
  faAngleDoubleLeft,
  faAngleRight,
  faAngleDoubleRight,
  faExclamationTriangle,
  faSlidersH,
  faInfoCircle,
  faLightbulb,
  faStar,
  faCogs,
  faEnvelope,
  faDatabase,
  faPlus,
  faBars
} from '@fortawesome/free-solid-svg-icons';

import {
  faHeart,
  faComment,
  faShareSquare
} from '@fortawesome/free-regular-svg-icons';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Header from './Header';
import MainContent from './MainContent';
import Downtime from '../Downtime';
import SystemStatus from './SystemStatus';

library.add(
  faFileAlt,
  faPencilAlt,
  faShareAlt,
  faTrashAlt,
  faSearch,
  faCheck,
  faArrowRight,
  faArrowLeft,
  faUserClock,
  faTv,
  faFilm,
  faSitemap,
  faDownload,
  faSignal,
  faEdit,
  faPaste,
  faQuestion,
  faCaretUp,
  faCaretDown,
  faTimes,
  faTimesCircle,
  faAngleUp,
  faAngleDown,
  faAngleLeft,
  faAngleDoubleLeft,
  faAngleRight,
  faAngleDoubleRight,
  faExclamationTriangle,
  faSlidersH,
  faInfoCircle,
  faLightbulb,
  faStar,
  faHeart,
  faComment,
  faShareSquare,
  faCogs,
  faEnvelope,
  faDatabase,
  faPlus,
  faBars
);

const Layout = ({ children }) => (
  <section className="tvt-layout">
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnVisibilityChange
      draggable
      pauseOnHover
    />
    <Downtime />
    <Header />
    <MainContent>{children}</MainContent>
    <SystemStatus />
  </section>
);

Layout.defaultProps = {
  children: null
};

Layout.propTypes = {
  children: PropTypes.node
};

export default Layout;
